export const errorMessage = (code) => {
  let message = "";
  switch (code) {
    case 1000:
      message = "All Fields should be filled!";
      break;
    case 2000:
      message = "Event's date has other event in between";
      break;
    case 2050:
      message = "Event's date has other event in between";
      break;

    default:
      message = "An unknown Error has been occurred.";
      break;
  }
  return message;
};
